<script setup>
import { useFooterSectionStore } from '@/stores/footer_sections';

const footerSectionStore = useFooterSectionStore();
// const is_chat_enabled = process.env.VUE_APP_CHAT_ENABLED == 'true';

</script>

<template>
	<template v-if="footerSectionStore.getContactSection">
		<div class="contact-flex">
			<template v-if="footerSectionStore.getContactSection.items.length > 0">
				<template v-for="item in footerSectionStore.getContactSection.items" :key="item.id">
					<div v-if="item.type === 'reach_us_by_phone_call'" class="mobile-width">
						<h6 class="contact-title">{{ $t('general.reach_us_by_phone') }}</h6>
						<template v-for="lang in item.languages" :key="lang.id">
							<template v-if="lang.pivot">
								<a class="btn-small no-hover no-border" :href="'tel:' + lang.pivot.body" style="width: 140px;">{{ lang.pivot.body }}</a>
							</template>
						</template>
					</div>
					<div v-if="item.type === 'ussd_code'" class="mobile-width">
						<h6 class="contact-title">{{ $t('general.paybill/ussd') }}</h6>
						<template v-for="lang in item.languages" :key="lang.id">
							<template v-if="lang.pivot">
								<p class="btn-small no-hover" style="height: 39px; width: 140px;">{{ lang.pivot.body }}</p>
							</template>
						</template>
					</div>
				</template>
			</template>
		</div>
	</template>
</template>

<style scoped>
.contact-flex {
	display: flex;
	align-items: flex-end;
	justify-items: start;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 15px;
}
html[dir="rtl"] .contact-flex {
	justify-content: flex-end;
}
.contact-title {	color: var(--white);
	font-size: 13px;
	text-align: center;
	font-weight: 700;
	padding-bottom: 5px;
}
.contact-number {
	color: var(--primary);
	font-weight: 700;
	text-decoration: none;
}

.contact-number-ussd {
	color: var(--primary);
	font-weight: 700;
}

.no-hover {
	color: var(--primary);
	font-weight: 700;
	pointer-events: none;
	cursor: default;
}

.no-border {
	border: none;
	text-align: left;
}

@media screen and (max-width: 767px){
	.contact-flex {
		justify-content: space-between;
	}

	.btn-small {
		font-size: 13px;
		text-wrap: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.mobile-width {
		width: 44%;
	}
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.btn-small {
		font-size: 13px;
		padding: 7px;
	}
}
</style>